<template>
  <!-- 转办 -->
  <div class="container">
    <div>
      <div class="cell-list">
        <!-- 省级 -->
        <div v-if="userInfo && userInfo.regionType == '1'">
          <div @click="supervisionCenterShow = true" class="cell">
            <div class="label">
              监理中心
              <span style="color: #F94F4E;font-family: PingFangSC-Regular;">*</span>
            </div>
            <div class="content">
              <span
                :class="{'qingxuanze': selectCenterItem.name === '请选择'}"
              >{{ selectCenterItem.name }}</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
        </div>
        <!-- 州市级 -->
        <div v-if="userInfo && userInfo.regionType == '2'">
          <div
            v-if="companyList && companyList.length > 0"
            @click="organizePickerShow = true"
            class="cell"
          >
            <div class="label">
              转办机构类型
              <!-- <span>*</span> -->
            </div>
            <div class="content">
              <span>{{ selectOrganize.name }}</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
          <div
            v-if="selectOrganize.code === 2 && companyList.length > 0"
            @click="companyPickerShow = true"
            class="cell"
          >
            <div class="label">
              销售企业
              <span style="font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #F94F4E;">*</span>
            </div>
            <div class="content">
              <span :class="{'qingxuanze': selectCompany.name === '请选择'}">{{ selectCompany.name }}</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
          <div
            v-if="selectOrganize.code === 1 || companyList.length === 0"
            @click="supervisionCenterShow = true"
            class="cell"
          >
            <div class="label">
              监理中心
              <span style="font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #F94F4E;">*</span>
            </div>
            <div class="content">
              <span
                :class="{'qingxuanze': selectCenterItem.name === '请选择'}"
              >{{ selectCenterItem.name }}</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
        </div>
        <!-- 区县级 -->
        <div v-if="userInfo && userInfo.regionType == '3'">
          <div @click="companyPickerShow = true" class="cell">
            <div class="label">
              销售企业
              <span style="font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #F94F4E;">*</span>
            </div>
            <div class="content">
              <span :class="{'qingxuanze': selectCompany.name === '请选择'}">{{ selectCompany.name }}</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
        </div>
      </div>
      <div class="supplement-box">
        <p class="title">
          补充说明
          <span style="font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #F94F4E;">*</span>
        </p>
        <van-field
              class="textarea"
              v-model="content"
              autosize
              type="textarea"
              maxlength="500"
              placeholder="请输入"
            />
        <!-- <textarea
          v-model="content"
          class="textarea"
          placeholder="请输入"
          cols="30"
          rows="10"
          maxlength="500"
        ></textarea> -->
        <div class="tip">{{ content.length }}/500</div>
      </div>
    </div>
    <div class="btn">
      <span @click="confirm" :class="{'btn-disable': btnDisable() || !content}">确定</span>
    </div>
    <!-- 销售企业类型弹出框 -->
    <van-popup
      class="assignPersonnelPicker-box"
      v-model="companyPickerShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="header">
        <span class="title">选择销售企业</span>
        <van-icon @click="companyPickerShow = false" size="12px" name="arrow-down" color="#A2A3A4" />
      </div>
      <div class="person-list" style="max-height: 310px;">
        <div
          v-for="(item, index) of companyList"
          :key="index"
          class="person-item"
          @click="selectCompanyHandle(item)"
        >
          <span class="name">{{ item.name }}</span>
          <van-icon
            v-if="item.tioId === selectCompany.tioId"
            class="select-icon"
            color="#36B374"
            name="success"
          />
        </div>
      </div>
    </van-popup>
    <!-- 监理中心弹出框 -->
    <van-popup
      class="assignPersonnelPicker-box"
      v-model="supervisionCenterShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="header">
        <span class="title">选择监理中心</span>
        <van-icon @click="supervisionCenterShow = false" size="12px" name="arrow-down" color="#A2A3A4" />
      </div>
      <div v-if="typeList.length > 0" class="person-list" style="max-height: 310px;">
        <div
          v-for="(item, index) of typeList"
          :key="index"
          class="person-item"
          @click="selectCenter(item)"
        >
          <span class="name">{{ item.name }}</span>
          <van-icon
            v-if="item.id === selectCenterItem.id"
            class="select-icon"
            color="#36B374"
            name="success"
          />
        </div>
      </div>
      <div v-else class="nodata">暂无数据</div>
    </van-popup>
    <!-- 机构类型弹出框 -->
    <van-popup
      class="assignPersonnelPicker-box"
      v-model="organizePickerShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="header">
        <span class="title">选择转办机构类型</span>
        <van-icon @click="organizePickerShow = false" size="12px" name="arrow-down" color="#A2A3A4" />
      </div>
      <div class="person-list" style="max-height: 310px;">
        <div
          v-for="(item, index) of organizationType"
          :key="index"
          class="person-item"
          @click="selectOrgani(item)"
        >
          <span class="name">{{ item.name }}</span>
          <van-icon
            v-if="item.code === selectOrganize.code"
            class="select-icon"
            color="#36B374"
            name="success"
          />
        </div>
      </div>
    </van-popup>
    <!-- <div>
      <div class="item line_bottom">
        <div class="left">
          <span>退货单号</span>
          <span>{{orderNumber}}</span>
        </div>
        <span>></span>
      </div>
      <div class="item line_bottom" @click="showType">
        <div class="left">
          <span>监理中心</span>
          <span class="result_style" :class="{'choosed':choose}">{{typeValue}}</span>
        </div>
        <img src="../../../../assets/image/right.png" class="back" />
      </div>
      <div class="result">
        <span class="info">办理要求</span>
        <textarea class="content" placeholder="请输入办理要求...." v-model="content"></textarea>
      </div>
      <div class="btn" v-if="isOriginHei">
        <span @click="confirm" :class="{'active':change}">确定</span>
      </div>
      <common-picker
        ref="commonPicker"
        :typeList="typeList"
        :code="code"
        @getTypeValue="getTypeValue"
      ></common-picker>
      <picker ref="commonPicker" :typeList="typeList" @getTypeValue="getTypeValue"></picker>
    </div>-->
  </div>
</template>

<script>
import api from "../../../../service/modules/refund.js";
import picker from "../components/picker";
// import { Toast } from 'mint-ui'
export default {
  components: {
    picker
  },
  data() {
    return {
      supervisionCenterShow: false,
      companyList: [
        { name: "hgis", tioId: 1 },
        { name: "hgis", tioId: 2 }
      ], // 企业列表
      selectCompany: {
        name: "请选择"
      }, // 选择的企业
      selectCenterItem: {
        name: "请选择"
      }, // 选择的监理中心
      supervisionCenterShow: false, // 监理中心弹框控制
      companyPickerShow: false, // 销售企业弹框控制
      organizePickerShow: false,
      typeValue: "请选择监理中心",
      typeList: [],
      code: "",
      content: "",
      flowId: this.$router.currentRoute.query.flowId,
      orderNumber: this.$router.currentRoute.query.number,
      choose: false,
      orgId: this.$store.state.refund.userInfo.orgId,
      isOriginHei: true,
      documentHeight: "", // 默认屏幕高度
      isFlag: true,
      belongCenterType: 1, // 1是监理，2是企业
      organizationType: [
        { name: "监理中心", code: 1 },
        { name: "销售企业", code: 2 }
      ], // 机构类型列表
      selectOrganize: {
        // name: "销售企业",
        // code: 2
      }, // 选择的机构类型
      userInfo: this.$store.state.refund.userInfo
    };
  },
  computed: {
    change() {
      return this.isFlag;
      // if ((this.code !== "") & (this.content.trim().length > 0)) {
      //   return true;
      // } else {
      //   return false;
      // }
    }
  },
  created() {
    this.documentHeight = document.documentElement.clientHeight;
    // this.flowId = this.$router.currentRoute.query.flowId
    // this.orderNumber = this.$router.currentRoute.query.number
    // this.orgId = this.$store.state.userInfo.orgId
    // if (this.orgId !== '') {
    this.getOrg();
    this.getCompany();
    // }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        if (this.documentHeight > document.documentElement.clientHeight) {
          this.isOriginHei = false;
        } else {
          this.isOriginHei = true;
        }
      })();
    };
  },
  methods: {
    // 选择监理中心
    selectCenter(item) {
      this.selectCenterItem = item;
      this.supervisionCenterShow = false;
    },
    // 选择企业
    selectCompanyHandle(item) {
      this.selectCompany = item;
      this.companyPickerShow = false;
    },
    // 选择机构类型
    selectOrgani(item) {
      this.selectOrganize = item;
      if (this.selectOrganize.code === 1) {
        this.selectCompany = {}
      } else {
        this.selectCenterItem = {}
      }
      this.organizePickerShow = false;
    },
    // 获取企业列表
    getCompany() {
      api.getDisposeEnterprise().then(res => {
        if (res.ret === 0) {
          this.companyList = res.data;
        } else {
          this.companyList = [];
        }
      });
    },
    // 获取监理中心列表
    getOrg() {
      api.getChildOrg().then(res => {
        if (res.ret === 0) {
          if (res.data && res.data.length > 0) {
            this.typeList = res.data.map(item => {
              return {
                name: item.name,
                id: item.id
              };
            });
          } else {
            this.typeList = [];
          }
        }
      });
      // api.org({ orgId: this.orgId }).then(res => {
      //   console.log(res);
      //   if (res.ret === 0) {
      //     this.typeList = res.data.map(item => {
      //       return {
      //         name: item.name,
      //         id: item.id
      //       };
      //     });
      //     // if (res.data.length > 0) {
      //     // let list = [];
      //     // res.data.map((item, index) => {
      //     //     list.push({ text: item.name, value: index, code: item.id });
      //     // });
      //     // this.typeList.push(list);
      //     // }
      //   }
      //   console.log("list", this.typeList);
      // });
    },
    // 判断当前角色是否是市级
    isCity() {
      // 市级的话regionCode的后两位是00
      const code = this.userInfo.regionCode;
      return code.substr(code.length - 2) === "00";
    },
    // 确定按钮不可点击样式
    btnDisable() {
      let flag = false;
      if (this.selectOrganize.code === 2) {
        // 如果是企业就判断是否选了企业
        flag = this.selectCompany.name === "请选择";
      } else if (this.selectOrganize.code === 1) {
        flag = this.selectCenterItem.name === "请选择";
      }
      return flag;
    },
    showType() {
      this.$refs.commonPicker.showPicker();
    },
    getTypeValue(value) {
      this.typeValue = value.name;
      this.code = value.id;
      this.choose = true;
    },
    confirm() {
      // let isFlag = false
      // 如果是省级的时候判断是否选了监理中心
      if (this.userInfo.regionType == "1") {
        if (this.selectCenterItem.name === "请选择") {
          return this.$Toast({
            message: "请选择监理中心"
          });
        }
      } else if (this.userInfo.regionType == "2") {
        // 如果时市级的时候
        if (this.companyList.length === 0) {
          // 如果没有企业判断是否选了监理中心
          if (this.selectCenterItem.name === "请选择") {
            return this.$Toast({
              message: "请选择监理中心"
            });
          }
        } else if (this.companyList.length > 0) {
          // 如果有直属企业的时候
          if (this.selectOrganize.code === 2) {
            // 如果选择了企业类型判断选择了企业
            if (this.selectCompany.name === "请选择") {
              return this.$Toast({
                message: "请选择销售企业"
              });
            }
          } else if (this.selectOrganize.code === 1) {
            // 如果选择了监理中心
            if (this.selectCenterItem.name === "请选择") {
              return this.$Toast({
                message: "请选择监理中心"
              });
            }
          }
        }
      } else {
        // 如果是区县的时候判断是否选了企业
        if (this.selectCompany.name === "请选择") {
          return this.$Toast({
            message: "请选择销售企业"
          });
        }
      }

      // if (this.selectOrganize.code === 1) {
      //   if (this.selectCenterItem.name === "请选择") {
      //     return this.$Toast({
      //       message: "请选择监理中心"
      //     });
      //   }
      // } else if (this.selectOrganize.code === 2) {
      //   if (this.selectCompany.name === "请选择") {
      //     return this.$Toast({
      //       message: "请选择销售企业"
      //     });
      //   }
      // }
      if (this.content.trim().length === 0) {
        this.$Toast({
          message: "请填写补充原因"
        });
      } else {
        this.isFlag = true;
        this.getFlow();
        //   if (this.isFlag) {
        //     this.isFlag = false;
        //   }
      }
    },
    getFlow() {
      let param = {};
      if (this.selectCenterItem && this.selectCenterItem.id) {
        param = {
          flowId: this.flowId,
          content: this.content,
          acceptAreaId: this.selectCenterItem.id,
          belongCenterType: 1,
          acceptName: this.selectCenterItem.name
        };
      } else if (this.selectCompany && this.selectCompany.tioId) {
        param = {
          flowId: this.flowId,
          content: this.content,
          acceptAreaId: this.selectCompany.enterpriseLibraryId,
          belongCenterType: 2,
          acceptName: this.selectCompany.name
        };
      }
      api.flow(param).then(res => {
        if (res.ret === 0) {
          this.$Toast({
            message: "操作成功"
          });
          this.isOriginHei = false;
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          // Toast({
          //     message: res.msg
          // })
        }
      });
    }
  }
};
</script>
<style scoped  lang="less">
.container {
  width: 100%;
  padding: 0 15px;
  min-height: 100vh;
  padding-bottom: 34px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .van-icon-arrow:before {
    font-size: 12px;
  }
  .cell-list {
    margin-bottom: 24px;
    .cell {
      padding: 20px 0;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .address-inp-icon {
        width: 16px;
        height: 16px;
        position: relative;
        right: 28px;
      }
      .address-inp {
        background-color: white;
        width: 100%;
        height: 44px;
        padding-right: 28px;
        padding-left: 15px;
      }
      .label {
        font-size: 14px;
        color: #666666;
        span {
          color: red;
          vertical-align: middle;
          margin-left: 2px;
        }
      }
      /deep/.content {
        display: flex;
        align-items: center;
        .van-field__control {
          text-align: right;
        }
        .van-radio__label {
          font-size: 14px;
          color: #171a1d;
        }
        .van-radio__icon {
          display: flex;
          align-items: center;
        }
        span {
          font-size: 14px;
          color: #171a1d;
        }
        .qingxuanze {
          color: #cccccc;
          font-weight: 400;
        }
        .arrow {
          font-size: 1px;
          vertical-align: sub;
          margin-left: 5px;
          color: #aaaaaa;
        }
      }
    }
  }
  .supplement-box {
    position: relative;
    // padding: 0 16px;
    .title {
      font-size: 14px;
      color: #666666;
      margin-bottom: 12px;
    }
    /deep/.textarea {
      width: 100%;
      background: #f8f9fb;
       padding: 16px 4px 16px 16px;
      border-radius: 4px 4px 0 0;
      border: 0;
      font-size: 14px;
      line-height: 20px;
      box-sizing: border-box;
      .van-field__control {
        min-height: 120px;
        max-height: 320px;
      }
        .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
    }
    .tip {
      text-align: right;
      padding-right: 16px;
      background: #f8f9fb;
      width: 100%;
      position: relative;
      top: -15px;
      font-size: 14px;
      color: #cccccc;
      border-radius: 0 0 4px 4px;
      line-height: 25px;
    }
  }
  .assignPersonnelPicker-box {
    padding: 0 16px;
    .header {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        color: #171a1d;
        font-weight: 600;
      }
    }
    .tab-box {
      display: flex;
      border-bottom: 1px solid #f5f6f9;
      padding-top: 11px;
      .tab {
        margin-right: 21px;
        font-size: 14px;
        color: #666666;
        padding-bottom: 14.5px;
      }
      .tab-active {
        margin-right: 21px;
        font-size: 14px;
        color: #171a1d;
        padding-bottom: 14.5px;
        border-bottom: 1px solid #36b374;
      }
    }
    .person-list {
      max-height: 350px;
      overflow: auto;
      padding-bottom: 40px;
      &::-webkit-scrollbar {
        display: none;
      }
      .person-item {
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #f5f6f9;
        .name {
          font-weight: 400;
          font-size: 16px;
          color: #171A1D;
          line-height: 16px;
        }
      }
    }
    .nodata {
      text-align: center;
      font-size: 16px;
    }
    .box1 {
      text-align: center;
      margin-top: 64px;
      padding-bottom: 87px;
      img {
        display: inline-block;
        width: 74px;
        height: 62px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 24px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
  }
  .item {
    display: flex;
    display: -webkit-flex;
    padding: 24px 0;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    align-items: center;
    .left {
      span:nth-child(1) {
        display: inline-block;
        width: 100px;
      }
      span {
        font-size: 14px;
        color: #333333;
      }
      .result_style {
        color: #cccccc;
      }
      .choosed {
        color: #333;
      }
    }
    .back {
      width: 5px;
      height: 9px;
    }
  }
  .result {
    .info {
      display: inline-block;
      padding: 22px 0;
      font-size: 14px;
      color: #4a4a4a;
    }
    .content {
      width: 100%;
      height: 180px;
      background-color: #f9f9f9;
      border: 0;
      outline: none;
      resize: none;
      padding: 16px 0 0 16px;
      box-sizing: border-box;
      // color:#D8D8D8;
      font-size: 14px;
      border-radius: 3px;
    }
  }
  .btn {
    width: 100%;
    height: 50px;
    // padding: 0 12px;
    // position: absolute;
    // left: 0;
    // bottom: 34px;
    span {
      width: 100%;
      height: 100%;
      display: inline-block;
      background-color: @base-color;
      text-align: center;
      line-height: 50px;
      color: 16px;
      font-size: 16px;
      color: #fff;
      border-radius: 3px;
    }
    .btn-disable {
      opacity: 0.5;
    }
  }
}
</style>
